module.exports = __webpack_public_path__ + "img/profess4.35e97a71.png";